(function () {
    'use strict';

    angular
        .module('app')
        .controller('locationSelectController', locationSelectController);

    locationSelectController.$inject = ['localization', '$scope'];

    function locationSelectController(localization, $scope) {
        var vm = this;
        vm.$onInit = init;
        vm.setLocation = setLocation;
        vm.openSelect = openSelect;
        vm.showLocationSelect = false;

        function init() {
        }

        function setLocation(location) {
            if (location != vm.location) {
                vm.location = location;
                localization.setLocation(location);
                vm.locationChange();
            }
        }

        function openSelect() {
            vm.showLocationSelect = !vm.showLocationSelect;
        }

    }
})();